<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        What is Spin the Names?
      </h3>
      <div class="text-stone-700 dark:text-stone-300 space-y-4">
        <p>
          <strong>Spin the Names</strong> is the web's favorite random name picker wheel that makes selection fun, fair,
          and engaging. Our interactive spinning wheel randomly selects names with a satisfying spin animation and
          celebration effects.
        </p>
        <p>
          Perfect for classrooms, events, giveaways, team meetings, and anywhere you need a truly random selection
          process that everyone can see and trust.
        </p>
        <p>
          With <strong>millions of spins</strong> each month, our wheel has become the go-to random selector for
          teachers, event organizers, and teams worldwide. Experience the excitement of the spin!
        </p>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-400 to-primary-600 flex-none"></div>
  </div>
</template>
